import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Dashboard } from 'services/action';
import { Page } from 'ui/components';
import { formatDate } from 'utilities/common';
import * as Section from './component';

const initialState = {
  filter: {
    date: new Date(),
    format: formatDate(new Date(), 'YYYY-MM'),
  },
  data: null,
  loading: true,
};

const DashboardScreen = () => {
  const Dispatch = useDispatch();
  const isLoading = useSelector(
    (state) => state?.Activity?.services['Dashboard.Receivable']
  );

  const [
    { filter, data, loading },
    setState,
  ] = React.useState(initialState);

  const $onLoad = async (e) => {
    const payload = {};

    if (e) {
      payload.monthly = e;
    }

    const res = await Dispatch(Dashboard.$receivable(payload));
    if (res?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: res?.data }));
    }
  };

  React.useEffect(() => {
    setState((prevState) => ({ ...prevState, loading: true }));
    $onLoad(filter?.format);
    setState((prevState) => ({ ...prevState, loading: false }));
  }, [filter]);

  React.useEffect(() => {
    if (filter?.date) return;

    setState((prevState) => ({
      ...prevState,
      filter: { date: new Date(), format: formatDate(new Date(), 'YYYY-MM') },
    }));
  }, [filter]);

  return (
    <Fragment>
      <Page>
        <Page.Header
          pretitle=""
          title="Dashboard"
          isLoading={loading}
          action={false}
        />
        <Page.Body className="bg-light p-3 pt-0 mt-3">
          <Section.CardStatisticShipment
            isLoading={isLoading}
            data={data?.summary}
          />
          <div className="row mb-3 mt-3">
            <div className="col-6">
              <Section.CardOverude
                isLoading={isLoading}
                data={data?.overdue}
              />
            </div>
            <div className="col-6">
              <Section.CardWillToLater
                isLoading={isLoading}
                data={data?.will_to_late}
              />
            </div>
          </div>
        </Page.Body>
      </Page>
    </Fragment>
  );
};

export default DashboardScreen;
